import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type {
  Place, PlaceId,
} from '~/places/places.types';
import {
  placeInListHoverEnd,
  placeInListHoverStart, placesSearchHoverStart, placesSearchHoverStop,
  placesToolCollapseSearch, placesToolExpandSearch,
} from '~/store/frontendState/places/places.actionCreators';
import { usePlacesSearchExpandedSearchesSelector } from '~/store/frontendState/places/places.selectors';
import { mapSettingsPlacesRemovePlaceFromSearch } from '~/store/mapSettings/places/mapSettingsPlaces.actionCreators';
import type { PlacesSearchId } from '~/store/mapSettings/places/mapSettingsPlaces.state';
import type { PlaceSearchListingItem } from './placesTool.container';
import { PlacesToolListingComponent } from './placesToolListing.component';

export const PlacesToolListingContainer = ({
  searches,
}: {
  searches: ReadonlyArray<PlaceSearchListingItem>;
}) => {
  const dispatch = useDispatch();
  const expandedSearches = usePlacesSearchExpandedSearchesSelector();

  const onSearchHovered = useCallback((searchId: PlacesSearchId) => {
    dispatch(placesSearchHoverStart({ searchId }));
  }, [dispatch]);

  const onSearchHoverStopped = useCallback(() => {
    dispatch(placesSearchHoverStop());
  }, [dispatch]);

  const onPlaceHover = useCallback((place: Place, search: PlacesSearchId) => {
    dispatch(placeInListHoverStart({ placeId: place.id, placeSearchId: search }));
  }, [dispatch]);

  const onPlaceHoverStopped = useCallback(() => {
    dispatch(placeInListHoverEnd());
  }, [dispatch]);

  const onPlaceRemoveFromSearch = useCallback((place: Place, search: PlacesSearchId) => {
    dispatch(mapSettingsPlacesRemovePlaceFromSearch({ searchId: search, placeId: place.id }));
  }, [dispatch]);

  const toggleSearch = useCallback((searchId: PlaceId) => {
    if (expandedSearches.has(searchId)) {
      dispatch(placesToolCollapseSearch(searchId));
    }
    else {
      dispatch(placesToolExpandSearch(searchId));
    }
  }, [dispatch, expandedSearches]);

  return (
    <PlacesToolListingComponent
      expandedSearches={expandedSearches}
      searches={searches}
      onToggleSearch={toggleSearch}
      onSearchHovered={onSearchHovered}
      onSearchHoverStopped={onSearchHoverStopped}
      onPlaceHover={onPlaceHover}
      onPlaceHoverStopped={onPlaceHoverStopped}
      onPlaceRemove={onPlaceRemoveFromSearch}
    />
  );
};
